import PropTypes from 'prop-types'

import {Map} from 'immutable'
import {connect} from 'react-redux'
import {Link} from 'react-router'

import AccountDropdown from './AccountDropdown'
import AdvisorSetting from './AdvisorSetting'
import * as Links from '../../../../shared_components/Links'

import {isFuneralHome} from '../../lib/firmTools'
import {findRawResourceById} from '../../../../lib/plan_data/userData'

export const LoggedInMenu = props => {
  let firmLinkDestination
  let firmLinkText

  const firmUserOnlyView = !props.currentUser.account_manager &&
    !props.currentUser.quarterback

  if (props.currentUser.account_manager) {
    firmLinkDestination = '/pro/firm-admin/all-firms'
    firmLinkText = ' All Firms'
  } else {
    firmLinkDestination = `/pro/firm/${props.currentUser.firm}/users`
    firmLinkText = 'Settings'
  }

  if (!props.currentUser.quarterback && props.firm.isEmpty()) return null

  return (
    <ul className='menu row-wrapper-sb' data-testid='logged-in-menu'>
      {
        firmUserOnlyView &&
        (
          <li className='menu-item'>
            <Link activeClassName='active' to='/pro' className='header-link'>
              Dashboard
            </Link>
          </li>
        )
      }
      {
        firmUserOnlyView && props.professionalDesignation &&
        !isFuneralHome(props.firm) &&
        (
          <li className='menu-item'>
            <AdvisorSetting
              advisors={props.advisors}
              firm={props.currentUser.firm}
              professionalDesignation={props.professionalDesignation}
            />
          </li>
        )
      }
      {
        !props.currentUser.quarterback &&
        (
          <li className='menu-item'>
            <Link
              activeClassName='active'
              to={firmLinkDestination}
              className='header-link'>
              {firmLinkText}
            </Link>
          </li>
        )
      }
      {
        props.currentUser.account_manager &&
        (
          <li className='menu-item'>
            <Link
              activeClassName='active'
              to='/pro/organization-admin/organizations'
              className='header-link'>
              Organizations
            </Link>
          </li>
        )
      }
      {
        props.currentUser.account_manager &&
        (
          <li className='menu-item'>
            <Link
              activeClassName='active'
              to='/pro/quarterback-seat-admin/quarterback-seats'
              className='header-link'>
              Concierges
            </Link>
          </li>
        )
      }
      {
        props.currentUser.firm_user && !isFuneralHome(props.firm) &&
        (
          <li className='menu-item'>
            <Links.ProResourceCenter className='header-link'>
              Resources
            </Links.ProResourceCenter>
          </li>
        )
      }
      {
        props.currentUser.quarterback &&
        (
          <li className='menu-item'>
            <Link
              activeClassName='active'
              to='/pro/quarterback-admin/clients'
              className='header-link'>
              Dashboard
            </Link>
          </li>
        )
      }
      <li className='menu-item'>
        <AccountDropdown currentUser={props.currentUser} />
      </li>
    </ul>
  )
}

LoggedInMenu.propTypes = {
  advisors: PropTypes.array,
  currentUser: PropTypes.shape({
    firm: PropTypes.number,
    account_manager: PropTypes.bool,
    firm_user: PropTypes.bool,
    quarterback: PropTypes.bool
  }),
  firm: PropTypes.instanceOf(Map),
  professionalDesignation: PropTypes.string
}

const mapStateToProps = (state, ownProps) => {
  const firm = findRawResourceById({
    rawResource: state.api.firms,
    id: ownProps.currentUser.firm
  })

  return {firm}
}

export default connect(mapStateToProps)(LoggedInMenu)
